import type { AnimLayerFakeButtonProps } from "./types";

export const DEFAULT_FAKE_BUTTON: Partial<AnimLayerFakeButtonProps> = {
  variant: "paybybank",
  size: "md",
  payByBank: true,
  bankLogos: true,
};
